import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { RenderContextComponent } from '../../../../../../../../models/base/render-context-component';

@Component({
  selector: 'app-the-woods-product-info-section',
  templateUrl: './the-woods-product-info-section.component.html',
  styleUrl: './the-woods-product-info-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class TheWoodsProductInfoSectionComponent extends RenderContextComponent {
  @Input() title: string;
  @Input() productInfo: string;
  @Input() productInfoClampTo: number = 1;
  setupViews() {}
  setupBindings() {}
}
